import { useCallback } from 'react';
import { authStore$ } from '../stores/auth.store';
import type { InitValidatePhoneParams } from '../types';

export const useInitValidatePhone = () => {
    return useCallback(async (params: InitValidatePhoneParams) => {
        authStore$.initValidatePhoneData.set(params);
    }, []);
};
